import { useEffect } from 'react';

export const SelectInputLoading: React.FC = () => (
  <div
    className='h-10 bg-bg-secondary animate-pulse rounded-lg'
    aria-busy='true'
    aria-label='Loading…'
  />
);

export const SelectInputError: React.FC<{ error?: unknown }> = ({ error }) => {
  useEffect(() => {
    console.error('[select-input] Failed to load options:', error);
  }, [error]);

  return (
    <div className='h-10 flex items-center px-3 bg-bg-tertiary rounded-lg text-body-small text-error-primary'>
      We couldn't load options
    </div>
  );
};
